<template>
  <!-- 图片上传 - 上传数量默认1张，多张的动态传入limit值即可 -->
  <div id="upLoad">
    <el-upload
      action="#"
      list-type="picture-card"
      :auto-upload="true"
      :class="{ hide: hideUpload }"
      :on-change="onChange"
      style="width: 100%"
      v-loading="loading"
      :element-loading-text="loadingText"
      :limit="limit"
      :http-request="uploadAction"
      :on-exceed="onExceed"
      :on-preview="handlePictureCardPreview"
      :before-remove="handleRemove"
      :file-list="fileList"
      :multiple="limit > 1 ? true : false"
      accept=".jpg,.png,.gif,.jpg,.bmp,.jpeg"
      ref="upload1"
    >
      <template #default>
        <el-icon><Plus /></el-icon>
      </template>
      <template #tip>
        <div style="overflow: hidden">
          <div v-if="isTip" class="el-upload__tip" style="color: #b1aeae">
            1. 图片格式要求：只能上传.jpg,.png,.gif,.bmp,.jpeg 的图片文件<br />
            2. 图片文件大小：不能超过5120kb
            <div>{{ isSize ? "3. " + textSize : "" }}</div>
          </div>
          <div style="width: 100%">
            <span class="label">图片地址:</span>
            <el-tooltip
              v-if="url"
              class="item"
              effect="dark"
              :content="url"
              placement="top-start"
            >
              <el-input
                style="width: 88%"
                v-model="url"
                placeholder="上传图片完成，自动生成图片地址数据"
                clearable
              ></el-input>
            </el-tooltip>
            <el-input
              v-else
              style="width: 88%"
              v-model="url"
              placeholder="上传图片完成，自动生成图片地址数据"
              clearable
            ></el-input>
            <el-button
              style="display: inline-block"
              type="primary"
              @click="handleCopyText(url)"
              >复制</el-button
            >
          </div>
          <div
            v-if="isYes"
            class="dialog-footer btn-area"
            style="padding-top: 20px; float: right"
          >
            <el-button size="large" type="primary" @click="onSubmit1()"
              >确定</el-button
            >
            <el-button size="large" type="danger" plain @click="handleClear()"
              >清空图片</el-button
            >
          </div>
        </div>
      </template>
    </el-upload>
    <el-dialog v-model="dialogVisible" append-to-body width="1000px">
      <img
        w-full
        :src="dialogImageUrl"
        style="padding: 30px; width: 100%"
        alt="Preview Image"
      />
    </el-dialog>
  </div>
</template>
<script>
import { uploadImg, removeImages } from "network/upload";
import { isNull, FormatUrlData, SUB_URL_Decode } from "common/utils";
import { ref, reactive, toRefs, onMounted, unref, watch, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "ImageUpload",
  props: {
    //接收父组件参数
    imagePath: {
      //用于初始化图片上传组件的图片文件路径：""为未上传时(即添加时使用),否则请赋值用户所上传图片的路径(组件将自动初始化)
      type: String,
      default: "",
    }, //另回调方法change-imagePath:用于用户上传图片后的回调父组件方法,该方法默认接收用户上传图片的路径imgPath,可通过该方法对用户所上传图片进行赋值
    imagePathList: {
      //接口传入的数据
      type: Array,
      default: () => [],
    },
    pathIndex: {
      type: Number,
      default: -1,
    },
    isYes: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    }, //图片上传数量限制
    isSize: {
      type: Boolean,
      default: false,
    },
    textSize: {
      type: String,
      default: "",
    },
    isTip: {
      type: Boolean,
      default: true,
    },
    isReduce: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      oldPath: "",
      loading: false, //加载状态开关
      loadingText: "loading...", //加载状态提示文本
      disabled: false,
      imgPath: "", //用户最终上传的图片
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUpload: false,
      limitCount: 0,
      filesUploadArr: [], //上传的数据
      isPostDelete: false, //是否请求接口
      filesUploadList: [], //新增图片
      url: "", //图片路径
    });

    // 监听导入的下标
    watch(
      () => props.pathIndex,
      (newVal) => {
        data.fileList = [];
        if (props.imagePath == "") {
          data.fileList = [];
          return;
        }
        data.fileList.push({ name: "默认已选图片", url: props.imagePath });
      }
    );
    //监听父组件传递id集合参数的变化
    watch(
      () => props.imagePath,
      (newVal, oldVal) => {
        //如果新传递的对象是已选就没必要重复加载，因为每次勾选后(父组件传递的值也会变化)都会触发该事件
        data.fileList = [];
        if (upload1.value) upload1.value.clearFiles();
        if (newVal) {
          data.fileList.push({ name: "默认已选图片", url: newVal });
        }
      }
    );

    watch(
      () => props.fileList,
      (newVal, oldVal) => {
        nextTick(() => {
          data.hideUpload = newVal.length >= props.limit;
        });
      }
    );
    const upload1 = ref();
    onMounted(() => {
      data.imgPath = props.imagePath; //用户最终上传的图片
      data.oldPath = props.imagePath;
      data.limitCount = props.limit;
      data.url = props.imagePath;
      //初始化调用后端接口，加载联动选择
      if (props.imagePath) {
        data.fileList = [];
        if (upload1.value) upload1.value.clearFiles();
        data.fileList.push({ name: "默认已选图片", url: props.imagePath });
      }
      data.loading = false;
      getDataImg(); // 初始化图片
    });
    //复制
    const handleCopyText = (url) => {
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      ElMessage.success("复制成功");
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    };
    // 点击确认
    const onSubmit1 = () => {
      if (data.filesUploadArr.length < 1) {
        ElMessage.error("请上传图片");
        return;
      }
      emit("close-dialog");
    };
    // 单页面多次调用组件初始化
    const getDataImg = () => {
      if (props.pathIndex > -1 && props.imagePathList.length > 0) {
        // 没有限制个数的时候传入的是数组就行
        // if (data.limitcount == 1) {
        data.fileList = props.imagePathList[props.pathIndex];
        // }
      }
    };
    const onChange = (file, fileList) => {
      data.hideUpload = fileList.length >= data.limitCount;
    };
    // 查看图片
    const handlePictureCardPreview = (file) => {
      nextTick(() => {
        data.dialogVisible = true;
        data.dialogImageUrl = file.url;
      });
    };
    // 向父组件发送数据
    const eventTrigger = () => {
      emit("change-imagePath", data.imgPath);
    };
    // 自定义上传行为,覆盖默认action
    const uploadAction = async (f) => {
      const files = f.file;
      //文件上传提示中限制了大小
      //这里来限制一下
      let howM = files.size / (1024 * 1024);
      if (howM > 5) {
        ElMessage.error("图片大小不能超过5M");
        abort();
      }
      let fd = new FormData();
      fd.append("file", files);
      data.loading = true;
      data.loadingText = "上传中...";
      await uploadImg(fd, 1).then((res) => {
        data.loading = false;
        if (res.isSuccessful == false) {
          data.fileList = [];
          if (upload1.value) upload1.value.clearFiles();
          ElMessageBox.alert(res.message, "提示", {
            confirmButtonText: "确认",
          });
          return false;
        }
        f.onSuccess(f);
        if (data.limitCount == 1) {
          data.fileList = [{ name: f.file.name, url: res.url }];
        } else {
          data.fileList.push({
            name: f.file.name,
            url: res.url,
          });
        }
        // 添加文件记录
        data.filesUploadArr.push({
          name: f.file.name,
          url: res.url,
        });
        data.imgPath = res.url;
        data.url = res.url;
        ElMessageBox.confirm(
          `上传成功! 需要该图片地址作为配置项的值吗？`,
          "更新配置项的值",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            eventTrigger();
            emit("close-dialog");
          })
          .catch(() => {});
      });
    };
    // 删除文件
    const deleteFile = (url) => {
      if (data.isPostDelete) {
        return;
      }
      removeImages(url)
        .then((res) => {
          if (res.code == 0) {
            ElMessageBox.alert(res.message, "提示", {
              confirmButtonText: "确认",
            });
            return false;
          }
          data.filesUploadArr = [];
        })
        .catch((err) => {
          ElMessageBox.alert("删除文件失败", "提示", {
            confirmButtonText: "确认",
          });
        });
    };
    // 父组件取消按钮
    // 取消按钮逻辑： 清除新上传文件数组
    const cancelData = () => {
      let paths = [];
      if (data.filesUploadArr.length > 0) {
        data.filesUploadArr.map((item) => {
          paths.push(item.url);
        });
      }
      if (paths.length > 0) {
        deleteFile(paths);
      }
      data.fileList = [];
    };
    const submitData = (imgPathArr) => {
      let paths = [];
      if (data.fileList.length == 1) {
        let url = data.fileList[0].url;
        var filesUploadArr = [];
        if (imgPathArr && imgPathArr.length > 1) {
          imgPathArr.map((item) => {
            filesUploadArr = data.filesUploadArr.filter((o) => o.url !== item);
          });
        } else {
          filesUploadArr = data.filesUploadArr.filter((o) => o.url !== url);
        }
        var deleteUrl = [];
        if (filesUploadArr.length > 0) {
          filesUploadArr.map((item) => {
            deleteUrl.push(item.url);
          });
        }
        if (
          !isNull(props.imagePath) &&
          data.fileList[0].url != props.imagePath
        ) {
          deleteUrl.push(props.imagePath);
        }
        if (deleteUrl.length > 0) {
          deleteFile(deleteUrl);
        }
        data.filesUploadArr = [];
      } else {
        cancelData();
      }
    };

    // val为最终提交的数据
    const submitData2 = (val, oldVal) => {
      var urlList = [];
      if (data.filesUploadArr && data.filesUploadArr.length > 0) {
        data.filesUploadArr.map((item) => {
          urlList.push(item.url);
        });
      }
      // 添加原数据
      if (oldVal && oldVal.length > 0) {
        urlList.push(...oldVal);
      }
      val.map((item) => {
        urlList = urlList.filter((o) => o != item);
        // 去空
        urlList = urlList.filter((item) => item);
      });
      if (urlList.length != 0) {
        deleteFile(urlList);
      }
      data.filesUploadArr = [];
    };
    // 提交清除图片
    const submitData1 = (val, oldVal) => {
      var newVal = [];
      var newOldVal = [];
      // val为数组类型
      if (
        Object.prototype.toString.call(val) == "[object Array]" &&
        val.length > 0
      ) {
        val.map((item) => {
          var data = FormatUrlData(item, 'src="');
          if (
            Object.prototype.toString.call(data) == "[object Array]" &&
            data.length > 0
          ) {
            data.map((item1) => {
              newVal.push(...FormatUrlData(item1, '"'));
            });
          } else {
            data = FormatUrlData(data, '"');
          }
          // newVal.push(...data);
        });
      }

      // val为字符串类型
      if (Object.prototype.toString.call(val) == "[object String]") {
        var data = FormatUrlData(val, 'src="');
        if (
          Object.prototype.toString.call(data) == "[object Array]" &&
          data.length > 0
        ) {
          data.map((item) => {
            newVal.push(...FormatUrlData(item, '"'));
          });
        } else {
          data = FormatUrlData(data, '"');
        }
      }
      if (
        Object.prototype.toString.call(oldVal) == "[object Array]" &&
        oldVal.length > 0
      ) {
        oldVal.map((item) => {
          var data = FormatUrlData(item, 'src="');
          if (
            Object.prototype.toString.call(data) == "[object Array]" &&
            data.length > 0
          ) {
            data.map((item) => {
              newOldVal.push(...FormatUrlData(item, '"'));
            });
          } else {
            newOldVal.push(...FormatUrlData(data, '"'));
          }
        });
      } else {
        var data = FormatUrlData(oldVal, 'src="');
        if (
          Object.prototype.toString.call(data) == "[object Array]" &&
          data.length > 0
        ) {
          data.map((item) => {
            newOldVal.push(...FormatUrlData(item, '"'));
          });
        } else {
          newOldVal.push(...FormatUrlData(data, '"'));
        }
      }
      submitData2(newVal, newOldVal);
    };
    const isImgsSubmitData = (pathList) => {
      let arrUrls = JSON.parse(JSON.stringify(data.filesUploadArr));
      props.imagePathList.map((item) => {
        if (item.Contents.indexOf("http") > -1) {
          arrUrls.push({ name: "原数据", url: SUB_URL_Decode(item.Contents) });
        }
      });
      pathList.map((item) => {
        if (item.Contents.indexOf("http") > -1) {
          arrUrls = arrUrls.filter((o) =>
            o.url != item.Contents ? SUB_URL_Decode(item.Contents) : item.url
          );
        }
      });
      var deleteUrl = [];
      arrUrls.map((item) => {
        deleteUrl.push(item.url);
      });
      if (arrUrls.length > 0) {
        deleteFile(deleteUrl);
      }
    };
  // 清空图片
  const handleClear = () => {
      if (data.fileList.length == 0) {
        data.imgPath = "";
        eventTrigger();
      } else {
         data.fileList = []
        data.imgPath = "";
        data.url = "";
        eventTrigger();
      }
  };
    //删除图片
    const handleRemove = (file, fileList) => {
      ElMessageBox.confirm("删除之后不能恢复,确定要删除吗!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var fId = file.uid;
          var _index = -1;
          for (var i = 0; i < data.fileList.length; i++) {
            var item = data.fileList[i];
            if (item.uid == fId) {
              _index = i;
            }
          }
          if (_index == -1) {
            ElMessage.error("删除图片失败");
            return false;
          }
          data.fileList.splice(_index, 1);
          if (data.fileList.length == 0) {
            data.imgPath = "";
            eventTrigger();
          } else {
            data.imgPath = data.fileList;
            eventTrigger();
          }
          data.hideUpload = data.fileList.length >= data.limitCount;
        })
        .catch(() => {});

      return false;
    };

    const emptyUrl = () => {
      let paths = [];
      if (data.filesUploadArr.length > 0) {
        data.filesUploadArr.map((item) => {
          paths.push(item.url);
        });
      }
      paths.push(props.imagePath);
      if (paths.length > 0) {
        deleteFile(paths);
      }
      data.fileList = [];
    };
    const onExceed = () => {
      ElMessage.warning("最多只能上传" + data.limitcount + "张");
    };

    return {
      ...toRefs(data),
      upload1,
      handleCopyText,
      onSubmit1,
      getDataImg,
      onChange,
      handlePictureCardPreview,
      eventTrigger,
      uploadAction,
      deleteFile,
      cancelData,
      submitData,
      submitData1,
      submitData2,
      isImgsSubmitData,
      handleRemove,
      emptyUrl,
      onExceed,
      handleClear
    };
  },
};
</script>
<style scoped>
.el-dialog__wrapper >>> .el-dialog {
  background-color: rgba(255, 255, 255, 0.1);
  margin-top: 12vh !important;
  position: static;
}
.el-dialog__wrapper >>> .el-icon-close {
  color: #f2f2f2;
  font-size: 26px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #666;
  text-align: center;
  line-height: 40px;
}
.el-dialog__wrapper >>> .el-dialog__headerbtn {
  top: 50px;
}
::v-deep.el-icon-close-tip {
  display: none !important;
}
::v-deep.is-ready {
  display: none;
}
.btn-area button {
  margin-top: 20px;
}
::v-deep.el-upload-list__item-thumbnail {
  object-fit: inherit !important;
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
.hide,
.none {
  display: inline-block;
}
.label {
  width: 100px;
  text-align: left;
  display: block;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  margin-top: 10px;
}
.el-input--suffix >>> .el-input__inner {
  margin-right: 30px;
}
.el-upload-list__item-thumbnail {
  object-fit: inherit !important;
}
</style>
